import React from 'react';
interface SectionHeaderProps {
  title: string;
  subtitle?: string;
  icon?: React.ReactNode;
}
export function SectionHeader({
  title,
  subtitle,
  icon
}: SectionHeaderProps) {
  return <div className="flex items-start space-x-3" data-id="element-672">
      {icon && <div className="p-2.5 bg-gradient-to-br from-amber-100 to-orange-100 rounded-xl text-amber-700 shadow-sm border border-amber-200 print:bg-white print:shadow-none print:border print:border-stone-300" data-id="element-673">
          {icon}
        </div>}
      <div className="flex-1" data-id="element-674">
        <h2 className="text-base sm:text-lg font-bold text-amber-900 print:text-base" data-id="element-675">
          {title}
        </h2>
        {subtitle && <p className="text-xs sm:text-sm text-stone-600 mt-0.5 print:text-xs print:hidden" data-id="element-676">
            {subtitle}
          </p>}
      </div>
    </div>;
}